import * as yup from 'yup';

const experienceFormSchema = yup.object({
  activities: yup.array(
    yup.lazy((activities) => {
      const length = Object.values(activities).filter((v) => !!v).length;

      if (length === 0) return yup.object();

      return yup.object({
        tag: yup.object().nullable().required('내용을 입력해주세요.'),
        title: yup.string().required('기관/장소를 입력해주세요.'),
        startDate: yup.lazy((startDate) => {
          return startDate ? yup.date() : yup.string().required('일자를 입력해주세요.');
        }),
        endDate: yup.lazy((endDate) => {
          return endDate
            ? yup.date().when('startDate', (startDate, schema) => {
                return startDate ? schema.min(startDate, '종료 일자가 시작 일자보다 빠릅니다.') : schema;
              })
            : yup.string().required('일자를 입력해주세요.');
        }),
        description: yup.string(),
      });
    }),
  ),
  foreignExperiences: yup.array(
    yup.lazy((activities) => {
      const length = Object.values(activities).filter((v) => !!v).length;

      if (length === 0) return yup.object();

      return yup.object({
        code: yup.object().nullable().required('국가를 입력해주세요.'),
        startDate: yup.lazy((startDate) => {
          return startDate ? yup.date() : yup.string().required('일자를 입력해주세요.');
        }),
        endDate: yup.lazy((endDate) => {
          return endDate
            ? yup.date().when('startDate', (startDate, schema) => {
                return startDate ? schema.min(startDate, '종료일자가 시작일자보다 빠릅니다.') : schema;
              })
            : yup.string().required('일자를 입력해주세요.');
        }),
        description: yup.string(),
      });
    }),
  ),
  experiences: yup.array(
    yup.object({
      description: yup.string(),
    }),
  ),
});

export default experienceFormSchema;
